import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  NavContainer,
  NavWrapper,
  NavLogo,
  ProfileContainer,
  ProfileText,
  SubMenu,
  MenuItems,
  IconBlock,
  MobileHeading,
} from "./navbarStyles";
import { CaretDown } from "@styled-icons/boxicons-regular/CaretDown";
import {Menu} from "@styled-icons/boxicons-regular/Menu";
import styled from "styled-components";
import { ListUl } from "@styled-icons/bootstrap/ListUl";
import { Speedometer } from "@styled-icons/ionicons-solid/Speedometer";
import { LogOut } from "@styled-icons/entypo/LogOut";
import { useSelector, useDispatch } from "react-redux";
import { logOut } from "../../redux/userSlice";
import { useRef } from "react";
import { useEffect } from "react";
import UseClickOutside from "../../helpers/UseClickOutside";

const CaretDownS = styled(CaretDown)`
  width: 30px;
`;

const ListUlS = styled(ListUl)`
  width: 16px;
  margin-right: 8px;
`;
const SpeedometerS = styled(Speedometer)`
  width: 16px;
  margin-right: 8px;
`;

const LogOutS = styled(LogOut)`
  width: 16px;
  margin-right: 8px;
`;

const MenuIcon = styled(Menu)`
  width:40px;
`

const Navbar = () => {
  const [isActive, setIsActive] = useState(false);
  const dispatch = useDispatch();
  const userData = JSON.parse(localStorage.getItem("userInfo"))?.users;
  const navigate= useNavigate();


  let menuRef= UseClickOutside(()=>{
    setIsActive(false)
  })

  const handleLogOut = () => {
    dispatch(logOut())
    setIsActive(false);
    navigate("/");
   
  }
 console.log(userData,'userData')
  return (
    <>
      <NavContainer>
        <NavWrapper>
          <NavLogo>
            <Link to="/atf-dashboard">
              <img
                src={window.location.origin + "/images/logo-inner.png"}
                alt="AvariWorld Logo"
              />
            </Link>
          </NavLogo>

          {userData ? (
            <>
            
            <ProfileContainer ref={menuRef}>
              <ProfileText onClick={() => setIsActive(!isActive)}>
                <h3>{userData?.name}</h3>
                <CaretDownS />
              </ProfileText>
              <IconBlock onClick={() => setIsActive(!isActive)}>
            <MenuIcon/>
            </IconBlock>

              {isActive && (
                <SubMenu >
                  <MobileHeading>{userData?.name}</MobileHeading>

                  <Link
                      className="link"
                      onClick={()=> setIsActive(false)}
                      to="tasks/all"
                      style={{ color: "grey" }}
                    ><MenuItems >
                    <ListUlS />
                    
                      Tasks
                  </MenuItems>
                    </Link>

                    <Link
                      className="link"
                      to="/atf-dashboard"
                      style={{ color: "grey" }}
                      onClick={()=> setIsActive(false)}
                    >
                  <MenuItems >
                    <SpeedometerS />
                      Dashboard
                  </MenuItems>
                    </Link>

                  <MenuItems onClick={handleLogOut}>
                    <LogOutS />
                    <span
                      style={{ color: "grey" }}
                    >
                      Logout
                    </span>
                  </MenuItems>
                </SubMenu>
              )}
            </ProfileContainer>
            </>
          ) : (
            <span>&nbsp;</span>
          )}
        </NavWrapper>
      </NavContainer>
    </>
  );
};

export default Navbar;
